import api from './config'

interface CreateConnectionResponse {
  authorization_url: string
}

const googleDriveAPI = {
  createConnection: async () => {
    const response = await api.post<CreateConnectionResponse>('/google_drive/connection')
    return response.data
  },

  destroyConnection: async () => {
    const response = await api.delete('/google_drive/connection')
    return response.data
  },
}

export default googleDriveAPI
